import { render, staticRenderFns } from "./TransporterTransferHistory.vue?vue&type=template&id=380de72a&scoped=true&"
import script from "./TransporterTransferHistory.vue?vue&type=script&lang=js&"
export * from "./TransporterTransferHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransporterTransferHistory.vue?vue&type=style&index=0&id=380de72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380de72a",
  null
  
)

export default component.exports